import {ValueObject} from '@s-ui/domain'

export class SubscriptionModelValueObject extends ValueObject {
  /**
   * @param {Object<MakeEntity>} make
   * @param {Object<ModelEntity>} model
   * */

  getMake() {
    return this._make
  }

  getModel() {
    return this._model
  }
}
